import React from 'react'

import LoadingSkeleton from '../../Generics/LoadingSkeleton'
import isMobile from '../../../../utils/detectMobileBrowser'

const SKELTON_HEIGHT = isMobile() ? '160px' : '200px'
const SKELTON_COUNT = isMobile() ? 4 : 12
const SKELTON_PRODUCTS = Array.from(Array(SKELTON_COUNT)).map((val, i) => ({ index: i }))

const ProductsGridSkelton = () => SKELTON_PRODUCTS.map(({ index }) => (
  <LoadingSkeleton
    key={index}
    height={SKELTON_HEIGHT}
  />
))

ProductsGridSkelton.displayName = 'ProductsGridSkelton'
ProductsGridSkelton.whyDidYouRender = true

export default React.memo(ProductsGridSkelton)
